import React from 'react';
import { Clickable, ClickableProps, Text, Stack } from '@moda/om';
import ChevronUpIcon from '@moda/icons/chevron-up-12';
import ChevronDownIcon from '@moda/icons/chevron-down-12';
import { SizeInventoryFragment } from '../../generated/types';
import { LOW_INVENTORY_AMOUNT } from '../../constants';
import './SizeSelectorButton.scss';

type Props = ClickableProps & {
  open?: boolean;
  selectedSize: SizeInventoryFragment | null;
};

export const SizeSelectorButton: React.FC<Props> = ({ open, selectedSize, ...rest }) => (
  <Clickable className="SizeSelectorButton" {...rest}>
    <Stack space={3} direction="horizontal" alignItems="center">
      <Text>{selectedSize ? selectedSize.size : 'Select a size'}</Text>
      {selectedSize?.available != null &&
        selectedSize.available > 0 &&
        selectedSize.available <= LOW_INVENTORY_AMOUNT && (
          <Text color="code-red">Only {selectedSize.available} left</Text>
        )}
    </Stack>
    {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
  </Clickable>
);
